import gql from 'graphql-tag';

export const MY_TEAMS_RESILIENCE_PULSE_CHECK = gql`
  query myTeamsResiliencePulseCheck {
    myTeamsResiliencePulseCheck
  }
`;
